/**
 * @file Popup Container Provider
 * @desc 指定子树中所有会渲染弹出框的组件（`Select`、`Dropdown` 等）的 popup container 逻辑
 */
import React, { createContext, useCallback, useContext } from 'react';
var getDefaultPopupContainer = function () { return window.document.body; };
var getPopupContainerCtx = createContext(null);
/** 从上下文得到“获取 popup container 的函数” */
export function useGetPopupContainer(fnFromProps) {
    var getPopupContainer = useContext(getPopupContainerCtx);
    return useCallback(function (node) {
        var _a, _b;
        return ((_b = (_a = fnFromProps === null || fnFromProps === void 0 ? void 0 : fnFromProps(node)) !== null && _a !== void 0 ? _a : getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer(node)) !== null && _b !== void 0 ? _b : getDefaultPopupContainer());
    }, [fnFromProps, getPopupContainer]);
}
/** 向子树提供 popup container */
export default function PopupContainerProvider(_a) {
    var containerRef = _a.containerRef, getContainerFromProps = _a.getContainer, children = _a.children;
    var getContainerFromRef = useCallback(function () { var _a; return (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) !== null && _a !== void 0 ? _a : null; }, [containerRef]);
    var getContainer = getContainerFromProps !== null && getContainerFromProps !== void 0 ? getContainerFromProps : getContainerFromRef;
    return (React.createElement(getPopupContainerCtx.Provider, { value: getContainer }, children));
}
//# sourceMappingURL=PopupContainerProvider.js.map